/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './item';

type PropsType = {
  item: any,
  isClone: boolean,
  setValidateDataLength?: (el: string, isRemove?: number) => void,
  panelClass?: string
};

const SortableList = (props: PropsType): any => {
  const _random = _.random(0, Date.now());

  const Container = SortableContainer(({ items, type, questions, donations }: {}): React.Element<'div'> => {
    let arr = type === 'questions' ? questions : items;

    arr = type === 'donations' ? donations : arr;

    const panelTitleRef = React.useRef(null);

    return (
      <div className="sortable">
        {arr.map((value: any, index: number): React.Element<'div'> => {
          const Component = props.item || null;

          return (
            <SortableItem
              panelClass={props.panelClass ? props.panelClass : ''}
              key={`item-${_random}-Container-${value}-${index}`}
              value={value}
              index={index}
              id={value.id}
              tempId={value.temp_id}
              data={{
                ...props,
                index
              }}
              isClone={props.isClone}
              panelTitleRef={panelTitleRef}
              setValidateDataLength={props.setValidateDataLength}
            >
              {Component ?
                <Component
                  value={value}
                  index={index}
                  id={value.id}
                  data={{
                    ...props,
                    index
                  }}
                  isClone={props.isClone}
                  panelTitleRef={panelTitleRef}
                  setValidateDataLength={props.setValidateDataLength}
                /> : null
              }

            </SortableItem>
          );
        })}
      </div>
    );
  });

  return <Container {...props} />;
};

export default SortableList;
